"use client";

import Link from "@casino/client/components/Link";
import Img from "@casino/legacyUi/Img";
import { CDN_IMG_URL } from "@workspace/casino_config/cdn";
import { cn } from "@workspace/frontend-ui";

type Props = {
  handle: string;
  name: string;
  isDarkScheme?: boolean;
};

const ProviderLogo: FC<Props> = ({ handle, name, isDarkScheme }) => (
  <div className="flex h-20 w-40 items-center justify-center px-4">
    <Link href={`/providers/${handle}`}>
      <Img
        className={cn(
          "h-10 opacity-40 hover:opacity-100",
          isDarkScheme && "invert",
        )}
        src={`${CDN_IMG_URL}/providers/new-icons/${handle}.svg`}
        alt={name}
        width={160}
        height={40}
      />
    </Link>
  </div>
);

export default ProviderLogo;
